let cloudinary = {
  api_key: '162514526899814',
  url: 'https://api.cloudinary.com/v1_1/mayway-werbung-pr-gmbh/upload',
  accountName: 'mayway-werbung-pr-gmbh',
  upload_preset: 'photomask',
  res_url: 'https://res.cloudinary.com/mayway-werbung-pr-gmbh/image/upload/'
}

module.exports = cloudinary;
